/// <reference types="google.maps" />
import { WeatherForecast } from '../../../../core/interface/weather-forecast';
import { Field } from '../../../../core/interface/entity';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrevisaoTempoService } from 'app/core/services/previsao-tempo.service';
import { UserTalhaoListService } from 'app/core/services/user-talhao-list.service';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthorizationService } from 'app/core/services/authorization.service';
import { AuthStateService } from 'app/core/services/auth-state.service';
import { _roleEnumUserClass } from 'app/utils/role.utils';
import { AgresSpinnerService } from 'app/shared/components/agres-spinner/agres-spinner.service';
import { FileManagerService } from 'app/core/services/file-manager.service';
import { AgresSpinnerCanvasService } from 'app/shared/components/agres-spinner-canvas/agres-spinner-canvas.service';
import { Location } from '@angular/common';
import { FeatureCollection } from 'isoxml';
import { UserFilesManager } from 'app/utils/user-files-manager';
import { AnalyticsService } from 'app/core/services/analytics.service';
import { Preferences } from 'app/shared/models/preferences.model';
import { TrailClass } from 'app/utils/trail.utils';
import { ShapefileReader } from 'app/utils/shapefile-reader';
import { NvgHistService } from 'app/core/services/nvg-hist.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  standalone: false,
  selector: 'app-visualizar-talhoes',
  templateUrl: './visualizar-talhoes.component.html',
  styleUrls: ['./visualizar-talhoes.component.scss'],
})
export class VisualizarTalhoesComponent implements OnInit {
  private static readonly RATE_MAP_COLOR_BUCKET_COUNT = 5;
  private static readonly KNOWN_RATE_PROPERTY_NAMES = [
    'rate',
    'vr_rate',
    'rate_ha',
    'target_rate',
    'apprate',
    'appl_rate',
    'taxa',
    'taxa_ha',
    'dose',
    'dose_ha',
  ];

  public offCanvasArquivos = new Subject<boolean>();
  @Input() title: string;
  @Input() fieldId: string | null;
  @Output() sendGeometryData = new EventEmitter<any>();
  @Input() onEmitVoltarParaListaDeTalhoes;
  @Input() emitEventEditTalhaoById;

  errorMessage = 'global.alert.msg-unexpected-error';

  selectedColor = '#000';

  isPolygonClosed = true;

  loading = false;

  fieldIdToBeDeleted: string = '';

  talhoes = [];

  filesUploaded = [];

  talhaoById: Field;

  imagePath;

  filteredData: any[] = [];

  talhoesById: any[];

  public months = [];

  public summarizedForecast = {
    icon: '',
    precipChance: '',
    relativeHumidity: '',
    windSpeed: '',
    temperature: 0,
  };

  public userLat = null;
  public userLng = null;

  public searchStr: string;

  public isLocationValid: boolean = false;

  apiData: boolean = false;

  geometry: FeatureCollection<any> = {
    features: [
      {
        geometry: {
          coordinates: [[]],
          type: 'Polygon',
        },
        properties: {},
        type: 'Feature',
      },
    ],
    type: 'FeatureCollection',
  };

  options: google.maps.MapOptions = {
    zoom: 10,
    mapTypeId: 'satellite',
    disableDefaultUI: true,
  };
  polygonsOptions: google.maps.PolygonOptions;
  vertices: google.maps.LatLngLiteral[] = [];

  public isButtonClickable: boolean = true;

  public showDataIrrigation: boolean = false;
  public showDataFertilization: boolean = false;
  public showButtonShapefileDownload: boolean = false;

  public showButtonRecomendation: boolean = false;

  public messageErrorResponseApi: any;
  public auth: any;
  private cloudantManager: UserFilesManager;
  updateIsPolygonClosed: Subject<boolean> = new Subject();
  fetchFieldData: Subject<boolean> = new Subject();

  private readonly authState = inject(AuthStateService);

  userNameLogged = '';
  userRole = '';
  ROLE_USERS_ENUM = _roleEnumUserClass.ROLE_ENUM;
  fileName: string;
  fieldsNames: any;
  alertTermsPrescriptions: boolean = true;
  userLogged: any;
  showOffCanvasArquivos: boolean;
  fieldKey: string;
  recommendationMapArray;
  guides: any[];
  guidesArray: Array<string>;
  boundariesArray: any;
  preferences: Preferences;
  trailClass: TrailClass;
  shpFiles: Array<string>;
  baseUrl: string;
  menuFieldFileStatus = false;
  titleButtonMenuFieldFile: string = 'Abrir menu de arquivos';
  listOfFiles: Array<string>;
  shapefileReader: ShapefileReader;
  userId: string;
  private loadedField = new Subject<Field>();
  loadedField$ = this.loadedField.asObservable();
  showButton = false;
  viewPort4k = false;

  constructor(
    public userTalhoesService: UserTalhaoListService,
    public translateService: TranslateService,
    public previsaoTempoService: PrevisaoTempoService,
    public httpClient: HttpClient,
    public router: Router,
    public authorizationService: AuthorizationService,
    public loadingAgresSpinner: AgresSpinnerService,
    public fileManagerService: FileManagerService,
    public loadingAgresSpinnerCanvas: AgresSpinnerCanvasService,
    public _location: Location,
    public readonly analyticsService: AnalyticsService,
    private readonly activeRoute: ActivatedRoute,
    public readonly nvgHistService: NvgHistService,
    private readonly toastr: ToastrService,
  ) {
    this.shapefileReader = new ShapefileReader();
    this.trailClass = new TrailClass();
    const usuarioLogado = this.authState.getUser();
    this.userId = usuarioLogado?.id;
    this.analyticsService.trackEvent('Opened a field', 'My Fields');

    this.auth = authorizationService.gethandler();
    this.cloudantManager = new UserFilesManager(fileManagerService, httpClient);
  }

  ngOnInit(): void {
    this.translateService
      .get('global.alert.ndvi-1')
      .subscribe((res: string) => {
        this.loadingAgresSpinner.toShow(res);
      });
    this.activeRoute.params.subscribe((params) => {
      this.fieldId = params['fieldId'];

      if (this.fieldId) {
        this.openTalhaoById(this.fieldId);
        this.loadedField$.subscribe((talhao) => {
          this.talhaoById = talhao; // Atualiza talhaoById após carregamento
          this.getFieldData(); // Chama função após talhao carregado
        });
      }
    });
    this.polygonsOptions = {
      fillColor: this.talhaoById?.color || '#ff0000',
      fillOpacity: 0.6,
    };

    this.userRole = this.authorizationService.getLoggedUserRole();
    this.userLogged = this.authState.getUser();

    this.userNameLogged = this.userLogged.Nome;
    this.viewPort4k = window.innerWidth >= 3000;

    this.translateService.onLangChange.subscribe(() => {
      this.titleButtonMenuFieldFile = this.menuFieldFileStatus
        ? 'fields.close-files-panel'
        : 'fields.open-files-panel';
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.viewPort4k = window.innerWidth >= 3000;
  }

  get heightMaps(): string {
    const is4k = this.viewPort4k;

    return is4k ? '650px' : '500px';
  }

  getFieldData() {
    const cropName = this.talhaoById.name;
    const params = { metadata: true };
    const itemsPerSection = 0;
    const section = 0;
    const searchTerm = '';

    this.nvgHistService
      .getHist(itemsPerSection, section, searchTerm, params, cropName)
      .subscribe(
        (fieldData) => {
          const stringData = JSON.stringify(fieldData);
          const parseData = JSON.parse(stringData);
          const countTaskField = parseData.count;

          if (countTaskField > 0) {
            this.showButton = true;
          } else {
            this.showButton = false;
          }
        },
        (error) => {
          console.error(error);
        },
      );
  }

  goBack() {
    this._location.back();
  }

  dashboard() {
    this.router.navigate(['/']);
  }

  openTalhaoById(id: string): void {
    this.userTalhoesService.getTalhaoId(id).subscribe((talhoes: Field) => {
      const talhao = talhoes;
      this.talhaoById = talhao;
      this.getFieldKey();
      this.getUserFiles();
      this.loadForecast(
        talhao.geometry.features[0].geometry.coordinates[0][0][1],
        talhao.geometry.features[0].geometry.coordinates[0][0][0],
      );
      this.selectedColor = talhao.color;
      if (talhao.staticMapImage === null) {
        talhao.staticMapImage =
          '../../../../../assets/images/gallery/thumbnail-talhaoImageById.png';
      } else {
        talhao.staticMapImage =
          'data:image/jpg;base64,' + talhao.staticMapImage;
      }
      talhao.totalArea = (+talhao.totalArea).toFixed(3);
      this.geometry = this.talhaoById.geometry;
      this.showBoundaries();
      if (this.geometry) {
        this.apiData = true;
        this.loadingAgresSpinner.toHide();
      }

      this.loadedField.next(talhao);
    });
  }

  getUserFiles() {
    this.cloudantManager
      .getUserFiles(this.userLogged.id)
      .subscribe(({ response }) => {
        if (response?.files?.fields) {
          const files = response.files.fields.hasOwnProperty(this.fieldId)
            ? response.files.fields[this.fieldId]
            : undefined;
          if (files) {
            this.shpFiles = files;
          } else {
            this.listOfFiles = [];
          }
        }
      });
  }

  getFieldKey() {
    this.fieldKey = this.talhaoById.name
      .replace(/\s+/g, '_')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  openOffCanvasArquivos() {
    this.offCanvasArquivos.next(true);
    this.analyticsService.trackEvent('Click button my files', 'My Fields');
  }

  loadForecast(lat, lng) {
    this.previsaoTempoService
      .getNowcast(lat, lng)
      .subscribe((dailyWeatherForecast) => {
        this.summarizedForecast = <WeatherForecast>(
          this.formatSummarizedForecast(dailyWeatherForecast)
        );
      });
  }

  formatSummarizedForecast(dailyWeatherForecast): WeatherForecast {
    return {
      icon: dailyWeatherForecast.Icone,
      precipChance: dailyWeatherForecast.Precipitacao,
      relativeHumidity: dailyWeatherForecast.Umidade,
      windSpeed: dailyWeatherForecast.Vento,
      temperature: Math.round(dailyWeatherForecast.Temperatura),
    };
  }

  createTarefa(): void {
    this.router.navigate([`/my-fields/criar-tarefa/${this.fieldId}`]);
    this.analyticsService.trackEvent('Click button tasks fields', 'My Fields');
  }

  openTarefaDoTalhaoById(): void {
    this.analyticsService.trackEvent('Click button tasks fields', 'My Fields');
    this.router.navigate([
      `/my-fields/gerenciamento-de-talhoes/listagem-tarefa-talhao/${this.fieldId}`,
    ]);
  }

  onUpdatePolygons() {
    return (geometry, polygonStatus: boolean, area?: number) => {
      this.isPolygonClosed = polygonStatus;
      this.geometry = geometry;
    };
  }

  async showShapefiles(array: {
    file: string;
    type: string;
    operation: string;
  }) {
    if (array.type === 'boundaries') {
      if (array.operation === 'clear') {
        this.boundariesArray = [];
      } else {
        this.showBoundaries();
      }
    } else {
      const shpFileName = array.file;
      let shpFile = await this.downloadFiles(shpFileName);
      const shp = await this.shapefileReader.openShapefile(shpFile);

      if (array.type === 'recommendation_files') {
        if (array.operation === 'clear') {
          this.recommendationMapArray = null;
        } else {
          const dbfFileName = this.shpFiles[array.type].filter(
            (file) => shpFileName.split('.')[0] + '.dbf' === file,
          )[0];
          if (dbfFileName) {
            const dbfFile = await this.downloadFiles(dbfFileName);
            const dbf = await this.shapefileReader.openDbfFile(dbfFile);
            const shapefileCoordinate =
              this.shapefileReader.getCoordinatesFromShapefile(shp);
            const referenceCoordinate = {
              lat: this.talhaoById.geometry.features[0].geometry
                .coordinates[0][0][1],
              lng: this.talhaoById.geometry.features[0].geometry
                .coordinates[0][0][0],
            };
            this.showRecommendationMap(
              shp,
              dbf,
              shapefileCoordinate,
              referenceCoordinate,
            );
          }
        }
      } else if (array.type === 'guides_files') {
        if (array.operation === 'clear') {
          this.guidesArray = [];
        } else {
          this.showGuides(shp);
        }
      }
    }
  }

  showBoundaries() {
    this.boundariesArray = [];
    let coordinates = [];

    this.geometry.features[0].geometry.coordinates.forEach((position) => {
      coordinates.push(
        position.map((item) => {
          return { lat: item[1], lng: item[0] };
        }),
      );
    });
    this.boundariesArray.push({
      paths: coordinates,
      color: this.selectedColor,
    });
  }
  showGuides(shp) {
    this.guides = [];
    shp.forEach((item) => {
      if (item.geometry.type === 'MultilineString') {
        item.geometry.coordinates.forEach((guide) =>
          this.guides.push({
            paths: guide.map((item) => {
              return { lat: item[1], lng: item[0] };
            }),
          }),
        );
      } else if (item.geometry.type === 'LineString') {
        this.guides.push({
          paths: item.geometry.coordinates.map((item) => {
            return { lat: item[1], lng: item[0] };
          }),
        });
      }
    });

    this.guidesArray = this.guides;
  }

  showRecommendationMap(
    shp,
    dbf,
    shapefileCoordinate,
    referenceCoordinate,
  ): void {
    if (
      !this.shapefileReader.isReferenceCoordinateFarFromShapefile(
        referenceCoordinate,
        shapefileCoordinate,
      )
    ) {
      const shapefile = this.shapefileReader.linkDBFDataToShapefileData(
        shp,
        dbf,
      );
      const property = this.getProperty(dbf);
      this.encontrarValoresRepresentativos(dbf, property);
      this.createRecommendedTrail(shapefile, property);
    } else {
      this.translateService
        .get('tasks.recommendation_map.error.map-too-distant-from-reference')
        .subscribe((res) => {
          this.toastr.warning(res, '', {
            positionClass: 'toast-top-full-width',
            disableTimeOut: false,
          });
        });
    }
  }

  /**
   * Computes 5 ascending threshold values (quantiles) from the numeric
   * rate values found in the shapefile's dbf records, used as legend/color
   * breakpoints for the rate map choropleth.
   *
   * @remarks
   * `trailColorPref(..., 'desc')` requires `preferences.red <= .orange <=
   * .yellow <= .lemonGreen` to bucket polygons correctly. Thresholds must
   * therefore be produced in non-decreasing order — an unordered set (e.g.
   * "most frequent value" instead of "value at each quantile") collapses
   * every polygon into a single color bucket.
   */
  encontrarValoresRepresentativos(array, property) {
    const numericValues = array
      .map((value) => value[property])
      .filter((value) => typeof value === 'number' && !Number.isNaN(value));

    if (numericValues.length === 0) {
      return;
    }

    const sortedValues = [...numericValues].sort((a, b) => a - b);
    const bucketCount = VisualizarTalhoesComponent.RATE_MAP_COLOR_BUCKET_COUNT;

    const thresholds = Array.from({ length: bucketCount }, (_, bucketIndex) => {
      const percentile = (bucketIndex + 1) / bucketCount;
      const rankIndex = Math.min(
        sortedValues.length - 1,
        Math.ceil(percentile * sortedValues.length) - 1,
      );
      return sortedValues[rankIndex];
    });

    this.subtitleArrayToPreferences(thresholds);
  }

  subtitleArrayToPreferences(arraySubtitle: number[]) {
    this.preferences = <Preferences>{
      red: arraySubtitle[0],
      orange: arraySubtitle[1],
      yellow: arraySubtitle[2],
      lemonGreen: arraySubtitle[3],
      green: arraySubtitle[4],
    };
  }

  /**
   * Resolves which dbf column holds the application rate value.
   *
   * @remarks
   * "Meus talhões" recommendation-map uploads have no column-selection UI
   * (unlike `RecommendationMapUploadComponent`), so the rate column must be
   * inferred. Known rate field names are matched first; if none match, the
   * last numeric column is used as a best-effort fallback for unfamiliar
   * shapefile schemas.
   */
  getProperty(file): string {
    const keys = Object.keys(file[0]);

    if (keys.length === 1) {
      return keys[0];
    }

    const knownRateProperty = keys.find((key) =>
      VisualizarTalhoesComponent.KNOWN_RATE_PROPERTY_NAMES.includes(
        key.toLowerCase(),
      ),
    );
    if (knownRateProperty) {
      return knownRateProperty;
    }

    let property: string;
    keys.forEach((key) => {
      if (typeof file[0][key] === 'number') {
        property = key;
      }
    });
    return property;
  }

  async downloadFiles(fileName: string): Promise<File> {
    const file = await this.cloudantManager.getFiles(
      this.userLogged.id,
      [fileName],
      'fields',
      this.fieldId,
    );

    return file;
  }

  createRecommendedTrail(shapefileArray, propertyToUse) {
    const mapFilterByProperty = shapefileArray.filter((polygon) => {
      const value = polygon.properties[propertyToUse];
      return value !== undefined && value !== null;
    });
    const clearTrail = (trailToClear) => {
      if (trailToClear) trailToClear.length = 0;
    };
    const customTrail = [];
    mapFilterByProperty.forEach((polygon) => {
      const convertedPolygon = this._convertTurfPolygonToCustomWithColor(
        polygon,
        propertyToUse,
      );
      customTrail.push(convertedPolygon);
    });
    this.recommendationMapArray = customTrail;
  }

  _convertTurfPolygonToCustomWithColor(turfPolygon, propertyToUse) {
    const color = this.trailClass.trailColorPref(
      'false',
      undefined,
      turfPolygon.properties[propertyToUse],
      this.preferences,
      'desc',
    ).trailColorScale;

    const customPolygon = {
      color: color,
      paths: [],
      valueOperation: turfPolygon.properties[propertyToUse],
    };

    if (turfPolygon.geometry.type === 'MultiPolygon') {
      customPolygon.paths = turfPolygon.geometry.coordinates.map((polygon) => {
        const lastIndex = polygon[0].length;
        return polygon[0].map((coord, index) => {
          if (index < lastIndex) return { lat: coord[1], lng: coord[0] };
        });
      });
    } else if (turfPolygon.geometry.type === 'Polygon') {
      const lastIndex = turfPolygon.geometry.coordinates[0].length;
      customPolygon.paths = turfPolygon.geometry.coordinates[0].map(
        (coord, index) => {
          if (index < lastIndex) return { lat: coord[1], lng: coord[0] };
        },
      );
    }

    return customPolygon;
  }

  openSidebarMenuFieldFiles() {
    this.menuFieldFileStatus = !this.menuFieldFileStatus;
    if (this.menuFieldFileStatus) {
      this.titleButtonMenuFieldFile = 'fields.close-files-panel';
    } else {
      this.titleButtonMenuFieldFile = 'fields.open-files-panel';
    }
  }

  navigateToTaskListWithFieldName() {
    this.router.navigate(['/gestao-operacao/gestao-arquivo'], {
      queryParams: { fieldName: this.talhaoById.name },
    });
  }

  navigateToEditFieldPage() {
    this.router.navigate([`/my-fields/edit/${this.fieldId}`]);
  }
}
